<template>
    <center v-if="idat">
        <div style="height:90px;"></div>
        <span style="font-size:36px; font-weight:600; color: #fff;">{{idat.title}}</span>
        <Info2Slider v-for="slider in idat.sliders" 
        v-bind:key="slider.ID" 
        v-bind:nowTxt="slider.nowTxt"
        v-bind:thenTxt="slider.thenTxt"
        v-bind:sliderTxt="slider.sliderTxt" />
    </center>
</template>
<script>
    import { ajaxGet,ajaxPost } from "../../../ajax";
import Info2Slider from './Info2Slider'
    import {apiUrl} from "@/main";

export default {
    components : { Info2Slider },
    data: function() {
        return {
                idat: undefined,
                infoId: undefined
        };
    },
    created() {
        this.infoId = this.$router.history.current.params.infoId;
        var assignmentFlag = (this.$router.history.current.query.Assignment === null) ? 'assignments' : 'content';
            if(this.infoId == 'undefined') alert("Not part of assignment.");
        ajaxGet(apiUrl()+"/"+assignmentFlag+"/" + this.infoId,
        (dat) => {
            //on success dat is called
            if(dat.component == "infographic2"){
                //This is the right component
                this.idat = dat.data;
                this.isAnswered = dat.answers;
                window.document.title = dat.title;
                //----------------------------------------------------------
                if(this.$router.history.current.query.Assignment === null && !this.isAnswered){
                    ajaxPost(apiUrl() +"/assignments/" + this.infoId, {
                    Data: {
                        seen: Date.now()
                    }
                },
                (suc) => {
                    console.log("Posted assignment:", suc);
                },
                (err) => {
                    console.log("Error :", err)
                }, localStorage.token);
                }
                //----------------------------------------------------------
            }else{
                //Wrong component type
                console.error("DATA MISMATCH on api call expected 'INFOGRAPHIC2' object, got '" + dat.component.toUpperCase() + "' object.");
            }
        },(err) => {
            //There was some error
            console.log(err);
        }, localStorage.token);
    }
}
</script>